import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PreviousQualificationEvent from './PreviousQualificationEvent';

function PreviousQualificationEvents({ events }) {
    return (
        <div className="qualified-golfers__events">
            {events.map((event) => (
                <div className="qualified-golfers__event" key={event.id}>
                    <PreviousQualificationEvent event={event}/>
                </div>
            ))}
        </div>
    );
}

PreviousQualificationEvents.propTypes = {
    events: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    const { events } = state;
    return { events };
};

export default connect(mapStateToProps)(PreviousQualificationEvents);
